export default {
  BUGSNAG_API_KEY: process.env.BUGSNAG_API_KEY || null,
}
